import React, { useState } from 'react';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@mui/material';
import { RackItem } from './merchandisingTypes';
import { variantLabel } from './restockPlan';
import { useMerchandisingWrite } from './useMerchandisingWrite';

const choices = [
  { label: '買了', outcome: 'bought', reason: undefined },
  { label: '太小', outcome: 'not_bought', reason: 'too_small' },
  { label: '太大', outcome: 'not_bought', reason: 'too_large' },
  { label: '想要的尺寸沒貨', outcome: 'not_bought', reason: 'size_unavailable' },
  { label: '版型不合', outcome: 'not_bought', reason: 'fit_disliked' },
  { label: '顏色考量', outcome: 'not_bought', reason: 'color' },
  { label: '價格考量', outcome: 'not_bought', reason: 'price' },
  { label: '再看看', outcome: 'not_bought', reason: 'thinking' },
];

const FittingQuickDialog: React.FC<{ item: RackItem; visitRef: string; enabled: boolean; onClose: () => void; onSaved: () => void }> = ({ item, visitRef, enabled, onClose, onSaved }) => {
  const write = useMerchandisingWrite(`fitting:${item.sku}`);
  const [variantId, setVariantId] = useState(Number(write.pending?.body.variant_id || 0));
  const [note, setNote] = useState(String(write.pending?.body.reason_note || ''));
  const variant = item.variants.find((row) => row.variant_id === variantId);
  const save = async (outcome: string, reason?: string) => {
    if (!enabled || (!variant && !write.pending)) return;
    if (await write.submit('post', '/api/noke/merchandising/fittings', {
      visit_ref: visitRef, variant_id: variantId, outcome,
      ...(reason ? { reason_code: reason } : {}), ...(variant?.size ? { size: variant.size } : {}),
      ...(note.trim() ? { reason_note: note.trim() } : {}),
    })) onSaved();
  };
  return <Dialog open onClose={() => !write.busy && onClose()} maxWidth="xs" fullWidth>
    <DialogTitle>記錄試穿 · {item.sku}</DialogTitle>
    <DialogContent>
      <Typography variant="body2" sx={{ mb: 2 }}>{item.title}</Typography>
      <TextField select fullWidth label="這次試穿的顏色尺寸" value={variantId || ''} disabled={write.locked} onChange={(event) => setVariantId(Number(event.target.value))}>
        {item.variants.filter((row) => row.variant_id > 0).map((row) => <MenuItem key={row.variant_id} value={row.variant_id}>{variantLabel(row.color, row.size)}</MenuItem>)}
      </TextField>
      <TextField fullWidth size="small" label="補充（例如想要 L，但沒貨）" value={note} disabled={write.locked} onChange={(event) => setNote(event.target.value)} sx={{ mt: 2 }} inputProps={{ maxLength: 500 }} />
      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', my: 2 }}>同一位客人可記多款。更換客人請在陳列頁按「下一位客人」。</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
        {choices.map((choice) => <Button key={choice.label} variant={choice.outcome === 'bought' ? 'contained' : 'outlined'} disabled={!enabled || !variant || write.locked} onClick={() => save(choice.outcome, choice.reason)}>{choice.label}</Button>)}
      </Box>
      {write.error && <Alert severity="error" sx={{ mt: 2 }}>{write.error}</Alert>}
    </DialogContent>
    <DialogActions><Button disabled={write.busy} onClick={onClose}>關閉</Button>{write.pending && <Button disabled={!enabled || write.busy} onClick={() => save('not_bought')}>重試同一筆</Button>}</DialogActions>
  </Dialog>;
};

export default FittingQuickDialog;
